<template>
    <div class="popup ju-popup analytics">
        <div class="header">
            <div class="title">Выберите период для отчета по порталу</div>
            <div class="close"></div>
        </div>

        <div class="content">
            <div class="form-field required">
                <div class="title">Период</div>
                <div class="value">
                    <DatePicker v-model="model" class="datepicker" select-range />
                </div>
            </div>
        </div>

        <div class="buttons">
            <button :disabled="errorDate" class="primary action" @click="download">
                <span class="text">Скачать отчёт</span>
            </button>
            <button class="action close">
                <span class="text">Отмена</span>
            </button>
        </div>
    </div>
</template>

<script>
import { changeQuarter } from '@/common/page_comp/Analytics/util.js';
import { currentUser } from '@/common/session.js';
import { dateRange } from '@/common/validators.js';
import { analyticsExport } from '@/restapi/audit.js';
import date from '@dsee/util/date.js';
import { showNotice } from '@dsee/components/popups/message.js';

export default {
    modal: {},
    data() {
        return {
            model: changeQuarter(-1),
        };
    },
    computed: {
        errorDate() {
            return !dateRange(this.model);
        },
    },
    methods: {
        open() {
            this.$modal.open();
        },
        close() {
            this.$modal.close();
        },
        download() {
            if (this.errorDate)
                return;

            const reqt = {
                from: date(this.model[0], 'iso.date'),
                to: date(this.model[1], 'iso.date'),
            };

            analyticsExport(reqt);
            showNotice({
                title: 'Отчёт готовится',
                text: 'По готовности отчет будет отправлен на вашу электронную почту ' + currentUser()?.email,
            });
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.analytics {
    .message {
        color: #FF0C0C;
    }

    .datepicker {
        &:deep(.dialog) {
            right: 0;
        }
    }
}
</style>
